import { createApp } from 'vue';
import Airlines from 'components/pages/Airlines.vue';

import { store } from 'components/store/store.js';
import { messages } from '../plugins/new-landing-i18n.js'
import { i18n } from '../plugins/i18n.js'
import { http } from '../../utils/http.js'

const _i18n = i18n(messages)

const app = createApp()

app.config.globalProperties.$http = http;

app.use(store)
app.use(_i18n)

app.component('airlines', Airlines)
app.mount('#airlines')
